export default __webpack_public_path__ + "static/media/caroussel-3.cec48d9f.png";